import { render, staticRenderFns } from "./UnitDetail.vue?vue&type=template&id=ead5ec9a&scoped=true"
import script from "./UnitDetail.vue?vue&type=script&lang=ts"
export * from "./UnitDetail.vue?vue&type=script&lang=ts"
import style0 from "./UnitDetail.vue?vue&type=style&index=0&id=ead5ec9a&lang=scss"
import style1 from "./UnitDetail.vue?vue&type=style&index=1&id=ead5ec9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead5ec9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ead5ec9a')) {
      api.createRecord('ead5ec9a', component.options)
    } else {
      api.reload('ead5ec9a', component.options)
    }
    module.hot.accept("./UnitDetail.vue?vue&type=template&id=ead5ec9a&scoped=true", function () {
      api.rerender('ead5ec9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/locations/units/components/UnitDetail.vue"
export default component.exports